import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -4,
			y: -4,
			width: 40,
			height: 40,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					clipPath: "url(#bgblur_0_14969_163464_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 4,
			width: 32,
			height: 32,
			rx: 10,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3198 15.6797L15.8798 18.2397L18.4398 15.6797",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8799 8V18.17",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 16.1797C24 20.5997 21 24.1797 16 24.1797C11 24.1797 8 20.5997 8 16.1797",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_0_14969_163464_clip_path",
			transform: "translate(4 4)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 10
			})
		}) })
	]
});
export default SvgDownloadIcon;
